import { useCallback } from "react";

import { IAttachment, IFormattedFile } from "library/types";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { ProfileContentWrap } from "components/styled";
import useEmployee from "hooks/useEmployee";
import { useCreateEmployeeAttachment } from "state/useCreateEmployeeAttachment";
import { useDeleteEmployeeAttachment } from "state/useDeleteEmployeeAttachment";

import { ManageEmployeeDocuments } from "./ManageEmployeeDocuments";

export function EmployeeDocuments() {
  const { employeeData } = useEmployee();

  const { t } = useTranslation();

  const { mutate: onCreateAttachment, isLoading: createAttachmentInProgress } =
    useCreateEmployeeAttachment(false);

  const { mutate: onDeleteAttachment, isLoading: deleteInProgress } =
    useDeleteEmployeeAttachment(false);

  const handleCreateAttachment = useCallback((newAttach: IFormattedFile | null) => {
    onCreateAttachment(
      {
        clientInternalNumberGOS: employeeData?.clientInternalNumberGos || 0,
        countryCode: employeeData?.countryCode || 0,
        payload: {
          attachmentName: newAttach?.name || "",
          attachmentContent: newAttach?.base64String || "",
          attachmentMimeType: newAttach?.type || "",
        },
      },
      {
        onSuccess: () => {
          toast.success(t("hbh.documentCreatedSuccessfully.label"));
        },
      }
    );
  }, []);

  const handleDeleteAttachment = useCallback((attach: IAttachment) => {
    onDeleteAttachment(
      {
        attachmentName: attach.attachmentName || "",
        clientInternalNumberGOS: employeeData?.clientInternalNumberGos || 0,
        countryCode: employeeData?.countryCode || 0,
        rowVersion: attach.rowVersion || "",
      },
      {
        onSuccess: () => {
          toast.success(t("hbh.documentDeletedSuccessfully.label"));
        },
      }
    );
  }, []);

  if (!employeeData) return null;
  return (
    <ProfileContentWrap>
      <ManageEmployeeDocuments
        attachmentActionsState={{
          createAttachmentInProgress,
          onCreateAttachment: handleCreateAttachment,

          deleteInProgress,
          onDeleteAttachment: handleDeleteAttachment,
        }}
        item={employeeData}
      />
    </ProfileContentWrap>
  );
}
